import { Injectable } from '@angular/core';
import { ResponseService } from 'src/app/core/models/response-service.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class LeadService {
	constructor(
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	public lead_detail(lead_id: number) {
		const url = `${environment.api}lead/${lead_id}/get_lead_by_id`;
		return this.http.get<ResponseService>(url);
	}

	public get_customer_notes_bylead(lead: number) {
		const url = `${environment.api}lead/get_customer_notes_bylead/${lead}`;
		return this.http.get<ResponseService>(url);
	}

	saveAll(payload) {
		const url = `${environment.api}lead/save_all`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	saveClientNotesByLead(leadId: number, notes: string, client: boolean) {
		var formData: any = new FormData();
		formData.append('LeadId', leadId);
		formData.append('Notes', notes);
		formData.append('Client', client);

		const url = `${environment.api}lead/save_client_notes_bylead`;
		var response = this.http.post<ResponseService>(url, formData);
		return response;
	}

	getQcLeadNotes(lead_id) {
		const url = `${environment.api}lead/${lead_id}/get_qc_lead_notes`;
		return this.http.get<ResponseService>(url);
	}

	getDispoLogNotes(prospect_id) {
		const url = `${environment.api}lead/${prospect_id}/get_dispo_log_notes`;
		return this.http.get<ResponseService>(url);
	}
}
